import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SupportService, SupportTicket } from '../support.service';

@Component({
    selector: 'app-support-ticket-list',
    standalone: false,
    templateUrl: './support-ticket-list.component.html',
    styleUrls: ['./support-ticket-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SupportTicketListComponent implements OnInit {
    @Output() selectTicket = new EventEmitter<string>();
    @Output() newTicket = new EventEmitter<void>();

    // A just-created ticket to surface immediately, ahead of Jira's search index.
    @Input() pendingTicket: any = null;

    tickets: SupportTicket[] = [];
    loading = true;
    error: string | null = null;

    constructor(
        private supportService: SupportService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.loadTickets();
    }

    loadTickets(): void {
        this.loading = true;
        this.error = null;
        this.supportService.listTickets().subscribe({
            next: (data) => {
                const values = data.values ?? [];
                // Keep the optimistic just-created row visible until the search
                // index returns it; once it does, the fetch already includes it
                // so we skip the prepend (dedup by issueKey).
                if (this.pendingTicket && !values.some((t: any) => t.issueKey === this.pendingTicket.issueKey)) {
                    values.unshift(this.pendingTicket);
                }
                this.tickets = values;
                this.loading = false;
                this.cdr.markForCheck();
            },
            error: (err) => {
                this.error = 'Unable to load tickets. Please try again.';
                this.loading = false;
                this.cdr.markForCheck();
            },
        });
    }

    getStatusClass(status: string): string {
        const s = (status || '').toLowerCase();
        if (s.includes('resolved') || s.includes('closed') || s.includes('done')) return 'status-resolved';
        if (s.includes('progress') || s.includes('open') || s.includes('waiting')) return 'status-open';
        return 'status-default';
    }
}
